let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kugUh")).then(() => parcelRequire('cC9xk'));